import { FREE_PLAN, PLAN_MARKETING, formatCheckIntervalLabel } from '../planMarketing'

export const PUBLIC_STATUS_PAGES_SECTIONS = [
  {
    heading: 'What is a public status page?',
    paragraphs: [
      'A public status page shows your customers and partners whether your services are operational—without requiring them to log in or contact support.',
      'Pingscalate status pages list your monitors, show uptime percentages, and display 24-hour and 7-day charts updated as checks run.',
    ],
  },
  {
    heading: 'Why share uptime publicly?',
    paragraphs: [
      'Transparency builds trust. When something goes wrong, a status page gives users a single place to check whether you are aware of the issue and when service was restored.',
      'It also reduces support load: fewer “is it down?” tickets when people can see status themselves.',
    ],
  },
  {
    heading: 'How Pingscalate status pages work',
    paragraphs: [
      'Create a status page in your dashboard, choose which HTTP monitors to include, and publish it at a custom URL slug (for example, yourcompany.pingscalate.com/status/your-slug or your configured domain).',
      'The page polls for updates automatically so visitors see current status without refreshing manually.',
    ],
  },
  {
    heading: 'Status page limits by plan',
    paragraphs: [
      `Every plan includes public status pages. The free plan includes ${PLAN_MARKETING.free.statusPages} status page; Pro includes ${PLAN_MARKETING.pro.statusPages}; Max includes ${PLAN_MARKETING.max.statusPages}.`,
      'HTTP uptime monitors appear on status pages. SSL and domain expiry monitors are tracked in your dashboard and alerts but are not shown on public status pages.',
    ],
  },
  {
    heading: 'Getting started',
    paragraphs: [
      `Sign up for a free Pingscalate account, add your monitors, and create a status page from the Status section. The free plan includes ${FREE_PLAN.monitors} monitors, ${formatCheckIntervalLabel(FREE_PLAN.intervalMinutes)}, and one public status page—no credit card required.`,
    ],
  },
] as const
